<template>
  <v-app>
    <div v-if="loading" style="height: 100vh">
      <v-layout fill-height justify-center align-center>
        <v-flex class="text-xs-center">
          <v-progress-circular
            :key="theme.color"
            indeterminate
            :color="theme.color"
          ></v-progress-circular>
        </v-flex>
      </v-layout>
    </div>
    <template v-else>
      <v-content class="mb-5">
        <merchant-detail
          v-model="pageProfile"
          id="merchant"
          :showSearch="false"
        >
          <!-- <div slot="header" class="text-xs-right">
            <v-spacer></v-spacer>
            <span class="mr-4">ยอดคงเหลือ</span>
            <span class="mr-4"
              ><v-icon small>mdi-bottle-soda-classic</v-icon>ขวดเล็ก {{ bottle.small }}</span
            >
            <span><v-icon>mdi-bottle-soda-classic</v-icon> ขวดใหญ่ {{ bottle.large }}</span>
          </div> -->
        </merchant-detail>
        <template v-if="page == 'products'">
          <v-layout wrap fill-height>
            <template v-if="filterProducts.length > 0">
              <template v-for="(product, pindex) in filterProducts">
                <v-flex
                  xs6
                  sm4
                  md3
                  lg2
                  xl2
                  class="pa-2"
                  v-if="product.type != 'none'"
                  :key="'product_' + filterProducts[pindex].id"
                  @selectProduct="onSelectProduct(filterProducts[pindex])"
                >
                  <nvbb-drink-product
                    v-model="filterProducts[pindex]"
                    :totalBottle="totalBottle"
                    :bottle="bottle"
                    @changeBottle="changeBottle"
                  ></nvbb-drink-product>
                </v-flex>
              </template>
            </template>
          </v-layout>

          <div style="height: 60px"></div>
          <v-tooltip top :value="!showTooltip">
            <template v-slot:activator="{ on }">
              <v-bottom-nav
                fixed
                :value="showCheckoutButton"
                :color="theme.color"
                dark
                style="height: 68px"
              >
                <v-btn
                  flat
                  value="nearby"
                  @click="onCheckout"
                  :disabled="!showCheckoutButton"
                >
                  <span>{{ $t("Checkout") }}</span>
                  <v-badge color="red" v-show="showCheckoutButton">
                    <template v-slot:badge>
                      <span>{{ grandTotalBottle }}</span>
                    </template>
                    <v-icon>mdi-cart-plus</v-icon>
                  </v-badge>
                </v-btn>
              </v-bottom-nav>
            </template>
            <span
              >เมื่อซื้อครบ
              <template v-if="shippingType == 'hub'"> 6 </template>
              <template v-else-if="shippingType == 'scg'"> 15 </template>
              <template v-else-if="shippingType == 'interexpress'">
                25
              </template>
              ขวดส่งฟรี</span
            >
          </v-tooltip>
        </template>
        <template v-else-if="page == 'checkout'">
          <v-container>
            <v-btn
              flat
              @click="
                page = 'products';
                goTo(0);
              "
            >
              <v-icon class="mr-2">mdi-arrow-left</v-icon> ย้อนกลับ
            </v-btn>
            <v-layout wrap>
              <v-flex xs12 md6 class="pa-2">
                <h3 class="title mb-3 mt-2">รายการสินค้า</h3>
                <v-card>
                  <template v-for="product in productlist">
                    <template v-if="product.bottle.small > 0">
                      <v-card-text :key="'cart_' + product.id + '_small'">
                        <v-layout>
                          <v-avatar radio="1" tile>
                            <img :src="product.photourl" />
                          </v-avatar>
                          <v-flex class="px-2 py-2">
                            {{ product.name }} (ขวดเล็ก)
                          </v-flex>
                          <v-flex class="px-2 py-2 text-xs-right">
                            x{{ product.bottle.small }}
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                      <v-divider
                        :key="'cart_' + product.id + '_divider_small'"
                      ></v-divider>
                    </template>
                    <template v-if="product.bottle.large > 0">
                      <v-card-text :key="'cart_' + product.id + '_large'">
                        <v-layout>
                          <v-avatar radio="1" tile>
                            <img :src="product.photourl" />
                          </v-avatar>
                          <v-flex class="px-2 py-2">
                            {{ product.name }} (ขวดใหญ่)
                          </v-flex>
                          <v-flex class="px-2 py-2 text-xs-right">
                            x{{ product.bottle.large }}
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                      <v-divider
                        :key="'cart_' + product.id + '_divider_large'"
                      ></v-divider>
                    </template>
                  </template>
                  <template v-if="other_products">
                    <template v-for="product in other_products">
                      <v-card-text :key="'cart_' + product.id">
                        <v-layout>
                          <v-avatar radio="1" tile>
                            <img :src="product.imgae_url" />
                          </v-avatar>
                          <v-flex class="px-2 py-2">
                            {{ product.name }}
                          </v-flex>
                          <v-flex class="px-2 py-2 text-xs-right">
                            x{{ product.qty }}
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                      <v-divider
                        :key="'cart_' + product.id + '_divider'"
                      ></v-divider>
                    </template>
                  </template>
                  <v-card-text>
                    <template v-for="val in producttype">
                      <template v-if="bottle[val] && totalBottle[val]">
                        <v-layout
                          :key="val + '_small'"
                          class="my-2"
                          v-if="
                            bottle[val].smallbottles - totalBottle[val].small !=
                            bottle[val].smallbottles
                          "
                        >
                          <v-flex>
                            ยอด
                            <template v-if="val">{{ val }}</template>
                            ขวดเล็กคงเหลือ
                          </v-flex>
                          <v-flex class="text-xs-right">
                            {{ bottle[val].smallbottles }}
                            <v-icon small>mdi-arrow-right</v-icon>
                            {{
                              bottle[val].smallbottles - totalBottle[val].small
                            }}
                          </v-flex>
                        </v-layout>

                        <v-layout
                          :key="val + '_large'"
                          class="my-2"
                          v-if="
                            bottle[val].bigbottles - totalBottle[val].large !=
                            bottle[val].bigbottles
                          "
                        >
                          <v-flex>
                            ยอด
                            <template v-if="val">{{ val }}</template>
                            ขวดใหญ่คงเหลือ
                          </v-flex>
                          <v-flex class="text-xs-right">
                            {{ bottle[val].bigbottles }}
                            <v-icon small>mdi-arrow-right</v-icon>
                            {{
                              bottle[val].bigbottles - totalBottle[val].large
                            }}
                          </v-flex>
                        </v-layout>
                      </template>
                    </template>

                    <v-layout
                      class="my-2"
                      v-if="
                        shippingType != 'hub' &&
                        shippingQuota[shippingType] > 0 &&
                        ((shippingType == 'scg' &&
                          totalBottle.large + totalBottle.small < 15) ||
                          (shippingType == 'interexpress' &&
                            totalBottle.large + totalBottle.small < 25))
                      "
                    >
                      <v-flex> รอบการจัดส่งคงเหลือ {{ shippingType }} </v-flex>
                      <v-flex class="text-xs-right">
                        {{ shippingQuota[shippingType] }}
                        <v-icon small>mdi-arrow-right</v-icon>
                        {{ shippingQuota[shippingType] - 1 }}
                      </v-flex>
                    </v-layout>
                    <v-layout class="my-2" v-else>
                      <v-flex> รอบการจัดส่งคงเหลือ {{ shippingType }} </v-flex>
                      <v-flex class="text-xs-right"> ฟรี </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-text>
                    <v-layout
                      class="my-2 title"
                      :style="{ color: theme.color }"
                    >
                      <v-flex> ยอดจัดส่งรวม </v-flex>
                      <v-flex class="text-xs-right">
                        {{ grandTotalBottle }}
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 md6 class="pa-2">
                <h3 class="title mb-3 mt-2">ที่อยู่การจัดส่ง</h3>
                <v-card>
                  <v-card-text>
                    <v-checkbox
                      :color="theme.color"
                      v-model="useSameAddress"
                      :label="`ใช้ที่อยู่เดียวกับที่อยู่ซื้อโควต้า`"
                      @change="switchUserAddress"
                    ></v-checkbox>
                    <div
                      :class="{ 'has-error': errors.has('customerName') }"
                      class="mb-1"
                    >
                      <v-text-field
                        :label="$t('Name')"
                        :data-vv-as="$t('Name')"
                        outline
                        name="customerName"
                        v-validate="'required'"
                        v-model="customerName"
                        light
                        :color="theme.color"
                        :hide-details="!errors.has('customerName')"
                        class="mb-2"
                        :error="errors.has('customerName') ? true : false"
                        :error-messages="
                          errors.has('customerName')
                            ? errors.first('customerName')
                            : ''
                        "
                        @blur="changeInfo"
                      ></v-text-field>
                    </div>

                    <template v-if="shippingType == 'hub'">
                      <div
                        :class="{ 'has-error': errors.has('hubLocation') }"
                        class="mb-1"
                      >
                        <v-select
                          v-model="hubLocation"
                          outline
                          label="สถานที่รับสินค้า"
                          key="บัญชี"
                          data-vv-as="สถานที่รับสินค้า"
                          v-validate="'required'"
                          :color="theme.color"
                          :items="hubLocationOptions"
                          name="hubLocation"
                          :hide-details="!errors.has('hubLocation')"
                          class="mb-2"
                          :error="errors.has('hubLocation') ? true : false"
                          :error-messages="
                            errors.has('hubLocation')
                              ? errors.first('hubLocation')
                              : ''
                          "
                        ></v-select>
                      </div>
                      <div v-if="currentHub" class="pt-2 pb-3">
                        <v-alert :value="true" color="info" outline>
                          <div
                            class="description"
                            style="word-break: break-word"
                          >
                            <nl2br tag="span" :text="currentHub.desc"></nl2br>
                            <br />
                            <a
                              v-if="currentHub.link"
                              :href="currentHub.link"
                              target="_blank"
                              rel="noopener noreferrer"
                              >{{ currentHub.link }}</a
                            >
                          </div>
                        </v-alert>
                      </div>
                    </template>
                    <template v-else>
                      <div
                        :class="{ 'has-error': errors.has('shippingAddress') }"
                        class="mb-1"
                      >
                        <v-textarea
                          outline
                          :label="$t('Shipping Address')"
                          name="shippingAddress"
                          rows="5"
                          :data-vv-as="$t('Shipping Address')"
                          style="resize: none; width: 100%"
                          v-model="shippingAddress"
                          v-validate="{
                            required: true,
                            regex: /([^0-9][1-9][0-9]{4})|^([1-9][0-9]{4})/,
                          }"
                          light
                          :color="theme.color"
                          :hide-details="!errors.has('shippingAddress')"
                          class="mb-2"
                          :placeholder="
                            $t('Ex. Address No., Village, Alley, and Road')
                          "
                          :error="errors.has('shippingAddress') ? true : false"
                          :error-messages="
                            errors.has('shippingAddress')
                              ? errors.first('shippingAddress')
                              : ''
                          "
                          @blur="changeInfo"
                        ></v-textarea>
                      </div>
                    </template>
                    <div
                      :class="{ 'has-error': errors.has('customerPhone') }"
                      class="mb-1"
                    >
                      <v-text-field
                        :label="$t('Tel.')"
                        :data-vv-as="$t('Tel.')"
                        outline
                        tyle="tel"
                        name="customerPhone"
                        light
                        :color="theme.color"
                        v-validate="{
                          required: true,
                          regex: /((\(?(\+\s*)([0-9]{2,3})\)?\s*[0]?)|[0])(([1-9][0-9]?))\s*\-?\s*([0-9]{3})\s*\-?\s*([0-9]{4,5})/,
                        }"
                        v-model="customerPhone"
                        :hide-details="!errors.has('customerPhone')"
                        class="mb-2"
                        :error="errors.has('customerPhone') ? true : false"
                        :error-messages="
                          errors.has('customerPhone')
                            ? errors.first('customerPhone')
                            : ''
                        "
                        @blur="changeInfo"
                      ></v-text-field>

                      <v-dialog
                        ref="dialog"
                        v-model="showDatePicker"
                        :return-value.sync="pickupdate"
                        persistent
                        lazy
                        full-width
                        width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="pickupdate"
                            label="วันที่รับสินค้า"
                            :data-vv-as="'วันที่รับสินค้า'"
                            prepend-inner-icon="event"
                            readonly
                            name="pickupdate"
                            v-validate="'required'"
                            :error="errors.has('pickupdate') ? true : false"
                            :hide-details="!errors.has('pickupdate')"
                            class="mb-2"
                            :error-messages="
                              errors.has('pickupdate')
                                ? errors.first('pickupdate')
                                : ''
                            "
                            outline
                            :color="theme.color"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="pickupdate"
                          scrollable
                          :color="theme.color"
                          :min="mindate"
                          :allowed-dates="allowedDates"
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            flat
                            :color="theme.color"
                            @click="showDatePicker = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            flat
                            :color="theme.color"
                            @click="$refs.dialog.save(pickupdate)"
                            >OK</v-btn
                          >
                        </v-date-picker>
                      </v-dialog>
                    </div>

                    <v-btn
                      :color="theme.color"
                      dark
                      block
                      @click="onProceedShipping"
                      >ยืนยันการส่งสินค้า</v-btn
                    >
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </template>

        <v-dialog scrollable v-model="showZoomImage" max-width="690">
          <v-card v-if="currentZoomImage">
            <v-card-actions class="text-xs-right">
              <v-layout>
                <v-flex>
                  <v-btn
                    flat
                    fab
                    icon
                    small
                    @click="
                      showZoomImage = false;
                      currentZoomImage = null;
                    "
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card-actions>
            <v-card-text class="pa-0 text-xs-center">
              <v-zoom
                :img="currentZoomImage"
                :width="'100%'"
                style="margin: auto"
              ></v-zoom>
            </v-card-text>
            <v-card-actions></v-card-actions>
          </v-card>
        </v-dialog>
      </v-content>
    </template>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import config from "@/config";
import axios from "axios";
import moment from "moment";
import MerchantDetail from "@/components/ecommerce/MerchantDetail.vue";
import Nl2br from "vue-nl2br";
import goTo from "vuetify/lib/components/Vuetify/goTo";
import vZoom from "vue-zoom";
import NvbbDrinkProduct from "./NvbbDrinkProduct";

export default {
  components: {
    MerchantDetail,
    Nl2br,
    vZoom,
    NvbbDrinkProduct,
  },
  computed: {
    showCheckoutButton() {
      var totalbottle = this.grandTotalBottle;
      if (this.shippingType == "hub") {
        // eslint-disable-next-line vue/no-async-in-computed-properties
        setTimeout(() => {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.showTooltip = totalbottle >= 6;
        }, 1000);
        return totalbottle >= 6;
      } else if (this.shippingType == "scg") {
        if (this.shippingQuota["scg"] == 0) {
          // eslint-disable-next-line vue/no-async-in-computed-properties
          setTimeout(() => {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.showTooltip = totalbottle >= 15;
          }, 1000);
          return totalbottle >= 15;
        } else {
          return totalbottle > 0;
        }
      } else if (this.shippingType == "interexpress") {
        if (this.shippingQuota["interexpress"] == 0) {
          // eslint-disable-next-line vue/no-async-in-computed-properties
          setTimeout(() => {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.showTooltip = totalbottle >= 25;
          }, 1000);
          return totalbottle >= 25;
        } else {
          return totalbottle > 0;
        }
      }
    },
    currentHub() {
      if (this.hubLocation) {
        return this.hubLocationOptions.find((el) => {
          return el.value == this.hubLocation;
        });
      } else {
        return "";
      }
    },
    ...mapGetters({
      isWholesale: "getWholesaleStatus",
      wholesale: "getWholesale",
      currentLang: "currentLang",
      loadingPageProfile: "getLoadingPageProfile",
      pageProfile: "getPageProfile",
      theme: "getTheme",
    }),
    pagename: function () {
      return this.$route.query.pageid
        ? this.$route.query.pageid
        : this.$route.params.id
        ? this.$route.params.id
        : undefined;
    },
    filterProducts() {
      return this.productlist.filter((el) => {
        return el.categoryid == 62;
      });
    },
    // totalBottle() {
    //   var result = this.getTotalBottle();
    //   return result;
    // },
    // grandTotalBottle() {
    //   var total = this.getTotalBottle();
    //   return this.producttype
    //     .map((el) => {

    //       if (total[el] !== undefined) {
    //         return total[el].large + total[el].small;
    //       } else return null;
    //     })
    //     .filter((el) => {

    //       return el != null;
    //     })
    //     .reduce((prev, curr) => {

    //       return prev + curr;
    //     }, 0);
    // },
  },
  data() {
    return {
      totalBottle: [],
      grandTotalBottle: 0,
      producttype: ["phytosmooz", "phytomylk", "none"],
      showDatePicker: false,
      pickupdate: null,
      mindate: moment().add("2", "days").format("YYYY-MM-DD"),
      customerName: "",
      shippingAddress: "",
      customerPhone: "",
      page: "products",
      loading: true,
      cart: [],
      bottle: {
        small: 0,
        large: 0,
      },
      shippingQuota: {
        scg: 0,
        interexpress: 0,
        hub: 0,
      },
      userid: null,
      categories: [],
      products: {},
      allproducts: [],
      productlist: [],
      hasSaleCategory: false,
      shippingType: "scg",
      showTooltip: true,
      other_products: null,
      shippingTypeOption: [
        { name: "SCG Express", value: "scg" },
        { name: "Inter Express", value: "interexpress" },
        { name: "HUB", value: "hub" },
      ],
      hubLocation: null,
      hubLocationOptions: [
        {
          text: "MITTA TOGO Cafe บางบอน - บางแค",
          value: "บางบอน - บางแค",
          desc: `📍บางบอน - บางแค📍\n1 นาที จาก รร.เลิศหล้า ถ.กาญจนาภิเษก\n⭐️ MITTA TOGO Cafe\n🕓 ช่วง 10:00-17:00 (086-5644152)`,
          link: "https://goo.gl/maps/3t16hNmM86MA5yq56",
        },

        {
          text: "Piece PremiumKups บางขุนเทียน",
          value: "บางขุนเทียน",
          desc: `📍 บางขุนเทียน 📍\n⭐️ Piece PremiumKups\n🕓 ช่วง 10:00-20:00 (081-8186961)`,
          link: "https://maps.app.goo.gl/ZXjXsgzoXuLxoKms7",
        },

        {
          text: "The Unnamed Cafe สาทร - นราธิวาส",
          value: "สาทร - นราธิวาส",
          desc: `📍สาทร - นราธิวาส📍\n⭐️ The Unnamed Cafe\n🕓 ช่วง 12:00-16:00 (085-6496169)`,
          link: "https://maps.app.goo.gl/i1YksGoSYTpMePmB7",
        },

        {
          text: "Baby BIB cafe พระราม 4 - สุขุมวิท 26",
          value: "พระราม 4 - สุขุมวิท 26",
          desc: `📍พระราม 4 - สุขุมวิท 26📍\n⭐️ Baby BIB cafe\nอยู่ใน Bambini Villa Community Mall\n🕓 ช่วง 13:00-20:00 (02-0564336)`,
          link: "https://maps.app.goo.gl/fKohDgcRw3PTGnxs8",
        },

        {
          text: "สนาม Flick FootBall วังทองหลาง - ลาดพร้าว",
          value: "วังทองหลาง - ลาดพร้าว",
          desc: `📍วังทองหลาง - ลาดพร้าว 📍\n⭐️ สนาม Flick FootBall (ใกล้ Central EastVille 1 นาที)\n> ช่วง 14:00-21:30 (098-8892203)`,
          link: "https://maps.app.goo.gl/qBvH8Ehnccsr689y7",
        },

        {
          text: "ร้าน Sweet tooth พันท้ายนรสิงห์",
          value: "พันท้ายนรสิงห์",
          desc: `📍พันท้ายนรสิงห์📍\n⭐️หมู่บ้านเดอะแกรนด์ ร้าน Sweet tooth\n🕓 ก่อน 9:00-17:00 (083-8886333)`,
        },
      ],
      quotaDetail: null,
      useSameAddress: false,
      currentZoomImage: null,
      showZoomImage: false,
    };
  },
  async mounted() {
    this.loading = true;
    await this.$store.dispatch("loadPageProfile", this.pagename);
    var beginningTime = moment();
    var endTime = moment("4:00pm", "h:mma");

    this.mindate = beginningTime.isBefore(endTime)
      ? moment().add("2", "days").format("YYYY-MM-DD")
      : moment().add("3", "days").format("YYYY-MM-DD");
    try {
      if (this.$route.query.nvbbshippingtype) {
        this.shippingType = this.$route.query.nvbbshippingtype;
      }

      if (this.$route.query.userid) {
        this.userid = this.$route.query.userid;
      } else {
        throw new Error("Not found user");
      }

      if (this.pageProfile) {
        if (this.pageProfile.pageid != "102459484852582") {
          throw new Error("Not found page");
        }
        document.title = this.pageProfile.pagename
          ? this.pageProfile.pagename
          : "";
        this.$store.dispatch("updateShopColor", this.pageProfile.shopcolor);

        await this.getCategories();
        await this.getProducts();
        await this.getnvbbcheckquota();

        try {
          var userdata = await this.getUserDetail();
          this.quotaDetail = await this.getUserQuotaDetail();
          var info = {
            name: null,
            phone: null,
            address: null,
          };
          if (this.quotaDetail) {
            info.name = this.quotaDetail.name;
            info.address = this.quotaDetail.address;
            info.phone = this.quotaDetail.phone;
            this.useSameAddress = true;
          } else if (userdata) {
            info.name = userdata.name ? userdata.name : this.quotaDetail.name;
            info.address = userdata.address
              ? userdata.address
              : this.quotaDetail.address;
            info.phone = userdata.phone
              ? userdata.phone
              : this.quotaDetail.phone;
          }

          var hublocation = this.hubLocationOptions.find((el) => {
            return el.value == info.address;
          });
          if (hublocation) {
            this.hubLocation = hublocation.value;
            info.address = hublocation.value;
          }

          this.customerName = info.name;
          this.customerPhone = info.phone;
          this.shippingAddress = info.address;
        } catch (error) {
          //
        }

        this.loading = false;
      } else {
        throw new Error("Not found page");
      }
    } catch (error) {
      if (error.message == "Not enough shipping quota") {
        await this.$swal({
          title: this.$t("รอบจัดส่งไม่เพียงพอ"),
          text: "กรุณาชำระรอบจัดส่งเพิ่ม",
          type: "info",

          confirmButtonText: this.$t("Confirm"),
          cancelButtonText: this.$t("Cancel"),
          reverseButtons: true,
        });
      } else if (error.message == "Not enough bottle") {
        await this.$swal({
          title: this.$t("จำนวนโควต้าไม่เพียงพอ"),
          text: "กรุณาชำระรอบจัดส่งเพิ่ม",
          type: "info",
          confirmButtonText: this.$t("Confirm"),
          cancelButtonText: this.$t("Cancel"),
          reverseButtons: true,
        });
      } else {
        console.log(error);
      }
    }
  },
  methods: {
    changeBottle() {
      this.summaryBottle();
    },
    summaryBottle() {
      var total = this.getTotalBottle();

      this.totalBottle = _.cloneDeep(total);
      this.grandTotalBottle = this.producttype
        .map((el) => {
          if (total[el] !== undefined) {
            return total[el].large + total[el].small;
          } else return null;
        })
        .filter((el) => {
          return el != null;
        })
        .reduce((prev, curr) => {
          return prev + curr;
        }, 0);
    },
    getTotalBottle() {
      // return {small: 0, large: 0};
      var bottles = {};
      this.producttype.forEach((el) => {
        bottles[el] = { small: 0, large: 0 };
      });

      return this.productlist
        .map((el) => {
          return { name: el.name, type: el.type, bottle: el.bottle };
        })
        .reduce(
          (prev, cur) => {
            try {
              var type = cur.type.toLowerCase();

              if (prev[type] === undefined) {
                prev[type] = _.cloneDeep(cur.bottle);
              } else {
                prev[type].small = prev[type].small + cur.bottle.small;
                prev[type].large = prev[type].large + cur.bottle.large;
              }
            } catch (error) {
              console.log(error);
            }
            return prev;
          },
          { ...bottles }
        );
    },
    zoomImage(image) {
      if (image) {
        this.currentZoomImage = image;
        this.showZoomImage = true;
      }
    },
    changeInfo() {
      this.useSameAddress = false;
    },
    switchUserAddress(value) {
      // eslint-disable-next-line no-console
      // console.log(value);
      if (value && this.quotaDetail) {
        this.cached_info = {
          name: this.customerName,
          address: this.shippingAddress,
          phone: this.customerPhone,
        };
        this.customerName = this.quotaDetail.name;
        this.shippingAddress = this.quotaDetail.address;
        this.customerPhone = this.quotaDetail.phone;
      } else if (this.cached_info) {
        this.customerName = this.cached_info.name;
        this.shippingAddress = this.cached_info.address;
        this.customerPhone = this.cached_info.phone;
      }
    },
    getUserQuotaDetail: function () {
      let vm = this;
      return new Promise((resolve, reject) => {
        axios
          .get(
            config.getConfig("serverUrl") +
              "lastorderaddress?pageid=" +
              vm.pageProfile.pageid +
              "&userid=" +
              vm.userid
          )
          .then((response) => {
            // JSON responses are automatically parsed.
            response = response.data;
            if (response.responsecode == 200) {
              if (response.data) {
                resolve(response.data);
              } else {
                reject();
              }
            } else {
              reject();
              // console.log(response);
            }
          });
      });
    },
    getUserDetail: function () {
      let vm = this;
      return new Promise((resolve, reject) => {
        axios
          .get(
            config.getConfig("serverUrl") +
              "lastorderaddress2?pageid=" +
              vm.pageProfile.pageid +
              "&userid=" +
              vm.userid
          )
          .then((response) => {
            // JSON responses are automatically parsed.
            response = response.data;
            if (response.responsecode == 200) {
              if (response.data) {
                resolve(response.data);
              } else {
                resolve(null);
              }
            } else {
              reject();
              // console.log(response);
            }
          });
      });
    },
    goTo(scrollTo) {
      return goTo(scrollTo);
    },
    async getnvbbcheckquota() {
      var request = {
        pageid: this.pageProfile.pageid,
        userid: this.userid,
      };
      var response = await axios.get(
        config.getConfig("serverUrl") + "nvbbcheckquota",
        {
          params: request,
          headers: { AUTHORIZATION: "Bearer xxx xxx" },
        }
      );
      if (response.status == 200 && response.data.responsecode == 200) {
        this.bottle = response.data.quota.product_qouta;
        var totalbottle = this.producttype
          .map((el) => {
            if (this.bottle[el])
              return (
                parseInt(this.bottle[el].bigbottles) +
                parseInt(this.bottle[el].smallbottles)
              );
            else return null;
          })
          .filter((el) => {
            return el != null;
          })
          .reduce((prev, curr) => {
            return prev + curr;
          }, 0);

        if (response.data.quota.other_products)
          this.other_products = response.data.quota.other_products;

        this.summaryBottle();
        this.shippingQuota.hub = 99999; //response.data.quota.hub
        this.shippingQuota.interexpress = response.data.quota.interexpress;
        this.shippingQuota.scg = response.data.quota.scg;

        if (totalbottle == 0) {
          throw new Error("Not enough bottle");
        }

        if (this.shippingQuota[this.shippingType] == 0) {
          // throw new Error("Not enough shipping quota");
          var result = await this.$swal({
            title: this.$t("รอบจัดส่งไม่เพียงพอ"),
            text: "กรุณาชำระรอบจัดส่งเพิ่ม",
            type: "info",
            showCancelButton: true,
            confirmButtonText: this.$t("ชำระรอบส่งเพิ่ม"),
            cancelButtonText: this.$t("Close"),
            reverseButtons: true,
          });

          if (result.value) {
            this.$router.push({
              name: "ecommerce",
              params: { id: this.pageProfile.pageid },
              query: this.$route.query,
            });
          }
        }
      } else {
        //
      }
    },
    allowedDates(val) {
      if (this.shippingType == "scg") {
        return moment(val).weekday() >= 2 && moment(val).weekday() <= 6;
      } else if (this.shippingType == "interexpress") {
        return moment(val).weekday() == 3 || moment(val).weekday() == 6;
      } else {
        return moment(val).weekday() == 3 || moment(val).weekday() == 6;
      }
    },
    onSelectProduct() {},
    getCategories() {
      let vm = this;
      return new Promise((resolve, reject) => {
        var data = {
          pageid: vm.pageProfile.pageid,
        };
        if (
          vm.pageProfile &&
          vm.pageProfile.useketshop == true &&
          vm.pageProfile.ketshop_api_key &&
          vm.pageProfile.ketshop_api_secret
        ) {
          data["ketshop_api_key"] = vm.pageProfile.ketshop_api_key;
          data["ketshop_api_secret"] = vm.pageProfile.ketshop_api_secret;
        }
        axios
          .get(config.getConfig("serverUrl") + "categories", {
            params: data,
          })
          .then((response) => {
            // JSON responses are automatically parsed.
            response = response.data;
            if (response.responsecode == 200) {
              vm.categories = [];
              var categories = response.categorylist.map(function (category) {
                var c = category;
                c.productCount = 0;
                return c;
              });
              vm.categories = categories;
              resolve();
            } else {
              reject();
            }
          });
      });
    },
    getProducts() {
      let vm = this;
      return new Promise((resolve, reject) => {
        var data = {
          pageid: vm.pageProfile.pageid,
        };
        if (
          vm.pageProfile &&
          vm.pageProfile.useketshop == true &&
          vm.pageProfile.ketshop_api_key &&
          vm.pageProfile.ketshop_api_secret
        ) {
          data["ketshop_api_key"] = vm.pageProfile.ketshop_api_key;
          data["ketshop_api_secret"] = vm.pageProfile.ketshop_api_secret;
        }
        axios
          .get(config.getConfig("serverUrl") + "products", {
            params: data,
          })
          .then((response) => {
            // JSON responses are automatically parsed.
            response = response.data;
            if (response.responsecode == 200) {
              vm.products = {};

              var result = vm.formatProducts(
                // eslint-disable-next-line no-undef
                _.cloneDeep(response.productlist),
                vm.categories
              );

              var allresult = vm.formatProducts(
                // eslint-disable-next-line no-undef
                _.cloneDeep(response.productlist)
              );
              vm.products = allresult.product_by_index;

              vm.productlist = _.cloneDeep(result.products);
              vm.allproducts = _.cloneDeep(allresult.products);

              vm.hasSaleCategory = false;

              vm.productlist.forEach((val) => {
                if (parseFloat(val.price) > parseFloat(val.discountprice)) {
                  vm.hasSaleCategory = true;
                } else {
                  var isDiscount = false;
                  if (val.productstock) {
                    var discountIndex = val.productstock.findIndex(function (
                      stock
                    ) {
                      return parseFloat(stock[3]) > parseFloat(stock[4]);
                    });
                    isDiscount = discountIndex != -1;
                  }
                  vm.hasSaleCategory = !isDiscount;
                }
              });
              resolve();
            } else {
              // console.log(response);
              reject();
            }
          })
          .catch(() => {
            reject();
          });
      });
    },
    formatProducts(products, categories) {
      var product_by_index = {};
      var newproducts = products.map((val) => {
        let product = _.cloneDeep(val);
        product.price = parseFloat(product.price);
        product.discountprice = parseFloat(product.discountprice);
        product.isOutOfStock = false;

        if (categories) {
          var categoryIndex = categories.findIndex(
            (x) => x.id === product.categoryid
          );

          if (categoryIndex != -1) {
            categories[categoryIndex].productCount++;
          }
        }
        var type = "none";

        if (product.productstock && product.productstock.length > 0) {
          var haveStock = false;

          product.productstock = product.productstock.map(function (
            pval,
            pindex
          ) {
            var stock = _.cloneDeep(pval);
            try {
              var typeAndName = pval[1].split("-");

              if (typeAndName.length == 2) {
                type = typeAndName[0];
                stock[1] = typeAndName[1];
              }
            } catch (error) {
              console.log(error);
            }

            if (parseInt(pval[2]) > 0) {
              haveStock = true;
            }

            var price = 0;
            var discount = 0;

            if (pval[3] == null && pval[4] == null) {
              price = parseFloat(val.price);
              discount = parseFloat(val.discountprice);
            } else {
              if (pval[3] == null) {
                price = parseFloat(val.price);
              } else {
                price = parseFloat(pval[3]);
              }

              if (pval[4] == null) {
                discount = pval[3];
              } else {
                discount = parseFloat(pval[4]);
              }
            }

            stock[3] = price;
            stock[4] = discount;
            return stock;
          });

          if (!haveStock) {
            product.isOutOfStock = true;
          }
        } else {
          product.isOutOfStock = true;
        }
        if (val) {
          product_by_index[val.id] = val;
        }

        product.type = type;

        product.bottle = {
          small: 0,
          large: 0,
        };

        return product;
      });

      return {
        products: newproducts,
        product_by_index: product_by_index,
      };
    },
    async onCheckout() {
      this.page = "checkout";
      await this.$nextTick();
      goTo(0);
    },
    async onProceedShipping() {
      var result = await this.$validator.validate();
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput();
        throw 400;
      }
      this.loading = true;
      var address =
        this.customerName +
        " , " +
        (this.shippingType == "hub"
          ? `${this.hubLocation}`
          : this.shippingAddress) +
        " , " +
        this.customerPhone;
      var products = this.productlist.filter((el) => {
        return el.bottle.small > 0 || el.bottle.large > 0;
      });
      var cart = [];
      try {
        products.forEach((el) => {
          if (el.bottle.small > 0) {
            cart.push({
              photourl: el.photourl,
              name: el.name,
              option: (el.type != "none" ? el.type + "-" : "") + "ขวดเล็ก",
              quantity: el.bottle.small,
            });
          }
          if (el.bottle.large > 0) {
            cart.push({
              photourl: el.photourl,
              name: el.name,
              option: (el.type != "none" ? el.type + "-" : "") + "ขวดใหญ่",
              quantity: el.bottle.large,
            });
          }
        });
        if (this.other_products) {
          var other_products = this.other_products.map((el) => {
            return {
              photourl: el.imgae_url,
              name: el.name,
              option: el.name,
              quantity: el.qty,
            };
          });
          cart = [...cart, ...other_products];
        }
      } catch (error) {
        //
      }


      var hubAddress = "";
      if (this.shippingType == "hub") {
        var hublocation = this.hubLocationOptions.find((el) => {
          return el.value == this.hubLocation;
        });

        if (hublocation) {
          hubAddress = `${hublocation.text} \n${hublocation.desc} \n${hublocation.link}`;
        }
      }

      var request = {
        cart: cart,
        pageid: this.pageProfile.pageid,
        userid: this.userid,
        address: address,
        shippingdate: moment(this.pickupdate).format("YYYY-MM-DD"),
        shippingtype: this.shippingType,
        phone: this.customerPhone,
        name: this.customerName,
        remark: hubAddress,
      };

      if (this.$route.query.from) {
        request.from = this.$route.query.from;
      } else {
        try {
          var device = this.$liff.getOS();
          var version = this.$liff.getVersion();
          await this.$liff.ready;

          if (
            this.userid.indexOf("__") != -1 &&
            device &&
            version &&
            !this.$liff.isInClient()
          ) {
            request.from = "livechat";
          }
        } catch (error) {
          // eslint-disable-next-line
          console.log(error);
        }
      }

      var response = await axios.post(
        config.getConfig("serverUrl") + "nvbbbanktransfernotify",
        request,
        {
          headers: { AUTHORIZATION: "Bearer xxx xxx" },
        }
      );

      response = response.data;
      var prefix_message = "ดำเนินการสั่งสำเร็จ Pre-order no: ";
      if (response.responsecode == 200) {
        await this.$swal({
          title: this.$t("Success"),
          text: this.$t("ได้รับคำสั่งการยอดสินค้าเรียบร้อย"),
          type: "success",
          confirmButtonText: this.$t("Confirm"),
          cancelButtonText: this.$t("Cancel"),
          reverseButtons: true,
        });

        // eslint-disable-next-line
        if (this.$liff.isInClient()) {
          // eslint-disable-next-line no-undef
          try {
            await this.$liff.sendMessages([
              {
                type: "text",
                text: prefix_message + response.orderid,
              },
            ]);
          } catch (error) {
            //alert(error.message);
          }

          // eslint-disable-next-line no-undef
          this.$liff.closeWindow();
          window.close();
        } else {
          // eslint-disable-next-line no-undef
          MessengerExtensions.requestCloseBrowser(
            function success() {},
            async function error() {
              window.close();
              window.location.assign(
                "https://www.messenger.com/closeWindow/?image_url=https://www.zwiz.ai/web/public/img/zwiz_logo_white.png&display_text=Closing window..."
              );
              window.location.reload();
            }
          );
        }
      } else if (response.responsecode == 400) {
        await this.$swal({
          title: this.$t("Error"),
          text: this.$t(response.reason),
          type: "error",
          confirmButtonText: this.$t("Confirm"),
          cancelButtonText: this.$t("Cancel"),
          reverseButtons: true,
        });
      } else if (response.responsecode == 201) {
        await this.$swal({
          title: this.$t("Success"),
          text: this.$t("ได้รับคำสั่งการยอดสินค้าเรียบร้อย"),
          type: "success",
          confirmButtonText: this.$t("Confirm"),
          cancelButtonText: this.$t("Cancel"),
          reverseButtons: true,
        });

        // eslint-disable-next-line
        if (this.$liff.isInClient()) {
          // eslint-disable-next-line no-undef
          try {
            await this.$liff.sendMessages([
              {
                type: "text",
                text: prefix_message + response.orderid,
              },
            ]);
          } catch (error) {
            //alert(error.message);
          }

          // eslint-disable-next-line no-undef
          this.$liff.closeWindow();
          window.close();
        } else {
          // eslint-disable-next-line no-undef
          MessengerExtensions.requestCloseBrowser(
            function success() {},
            async function error() {
              window.close();
              window.location.assign(
                "https://www.messenger.com/closeWindow/?image_url=https://www.zwiz.ai/web/public/img/zwiz_logo_white.png&display_text=Closing window..."
              );
              window.location.reload();
            }
          );
        }

        window.close();
        window.location.reload();

        // let url = "/ecommerce/" + this.pagename;
        // if (this.userid && this.userid != null && this.userid != "") {
        //   url += "?userid=" + this.userid;
        // }
        // this.$router.push({ path: url });
      } else {
        await this.$swal({
          title: this.$t("Error"),
          text: this.$t("Something went wrong. Please try it again.."),
          type: "error",
          confirmButtonText: this.$t("Confirm"),
          cancelButtonText: this.$t("Cancel"),
          reverseButtons: true,
        });
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
